
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["notify","CancelUpload","Upload"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "959d2ab8fb8a6c28faa1.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "959d2ab8fb8a6c28faa1.worker.js");
					addMethods(w, methods)
					
					return w
				}
			